import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {
    ConditionalBlockModel,
    IConditionalBlockModel
} from "@app/workflow-common/services/models/ConditionalBlockModel";
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";

@Component({
  selector: 'app-conditional-block-widget',
  templateUrl: './conditional-block-widget.component.html',
  styles: []
})
export class ConditionalBlockWidgetComponent implements OnInit {

    @Output() close:EventEmitter<{}> = new EventEmitter<{}>();
    @Input() hasBranch: boolean = false;
    @Input() workflowType: string;
    @Input() blockObject;
    @Input() dagSourceModel: DagSourceModel;
    @Input() nodeOptions: INodeOptions = undefined;

    form: FormGroup;
    conditionalBlockData:{} = {};
    isFormSubmitted:boolean = false;
    showDeleteBtn: boolean = false;
    select2Instance: any = undefined;

    inputModel: IConditionalBlockModel = undefined;
    fields: any[];
    constructor(
        private formBuilder: FormBuilder,
    ) { }

    ngOnInit() {
        this.conditionalBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.blockObject.key);
        const blockObject = { ...this.blockObject };
        const modelData = blockObject['model'] ? blockObject['model'] : undefined;
        if(modelData) {
            this.showDeleteBtn=true;
        }
        this.inputModel = new ConditionalBlockModel(modelData);
        this.fields = Object.values(this.dagSourceModel.getFieldMetadata());
        this.form = this.formBuilder.group({
           col_name: new FormControl(this.inputModel.col_name, [Validators.required]),
        });
        //console.log('conditional',this.conditionalBlockData, blockObject, this.inputModel);
        //console.log('conditional',this.fields);
    }

    closeModal() {
        this.close.emit({
            action: 'close',
            data: null
        });
    }

    remove() {
        this.close.emit({
            action: 'remove_block',
            data: this.blockObject
        });
    }

    setSelect2Instance(event:any) {
        this.select2Instance = event;
        if(this.hasBranch) {
            this.select2Instance.select2('enable', false);
        }
    }

    save() {
        this.isFormSubmitted=true;
        const blockObject = {...this.blockObject};
        const col_name = this.form.get('col_name') ? this.form.get('col_name').value : null;
        if(col_name){
            const selectedField = this.fields.find(f => f.col_name === col_name);
            const fieldType = selectedField.fieldType;
            blockObject.model = new ConditionalBlockModel({
                col_name,fieldType
            });
        }

        this.close.emit({
            action: 'save_and_close',
            data: blockObject
        });
    }

}
